import { siteLocales } from '@yola/ws-sdk';
import getLanguages from './get-languages';
import getCountries from './get-countries';
import getUsedLanguages from './get-used-languages';
import prepareLanguageSelectorFlagsMarkup from './prepare-language-selector-flags-markup';
import setLanguageSelector from './set-language-selector';
import deleteLanguageSelector from './delete-language-selector';

const updateLanguageSelector = async () => {
  const mainLocale = siteLocales.accessors.getMainLocale();
  const locales = siteLocales.accessors.getSiteLocales();
  const languages = getLanguages();
  const countries = getCountries();
  const usedLanguages = getUsedLanguages(locales, languages, countries);

  if (usedLanguages.length > 1) {
    const languageSelectorMarkup = await prepareLanguageSelectorFlagsMarkup(usedLanguages);
    setLanguageSelector(languageSelectorMarkup, mainLocale);
    return;
  }

  deleteLanguageSelector();
};

export default updateLanguageSelector;
